export default __webpack_public_path__ + "static/4-b8d3908f11992549165a5035505887fc.jpg";